import React from 'react';
import styled from '@emotion/styled';
import ClinicalNoteButton from './ClinicalNoteButton';
import ClinicalNoteLink from './ClinicalNoteLink';
import { file as filePropType } from './proptypes';

const propTypes = {
    file: filePropType.isRequired,
};

const defaultProps = {};

const ClinicalNoteLinkStyle = styled('div')`
    .file-name {
        margin-right: 3px;
    }
`;

function ClinicalNoteDownload({ file }) {
    return (
        <ClinicalNoteLinkStyle>
            {file.inAwsBucket ? <ClinicalNoteButton file={file} /> : <ClinicalNoteLink file={file} />}
        </ClinicalNoteLinkStyle>
    );
}

ClinicalNoteDownload.propTypes = propTypes;
ClinicalNoteDownload.defaultProps = defaultProps;

export default ClinicalNoteDownload;
